import { render, staticRenderFns } from "./SortingModeManagement.vue?vue&type=template&id=0ead6538&scoped=true"
import script from "./SortingModeManagement.vue?vue&type=script&lang=js"
export * from "./SortingModeManagement.vue?vue&type=script&lang=js"
import style0 from "./SortingModeManagement.vue?vue&type=style&index=0&id=0ead6538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead6538",
  null
  
)

export default component.exports